<template>
  <div>
    <div
      v-show="errorMessage"
      class="toast-container position-absolute top-0 end-0"
      style="z-index: 1100"
    >
      <div
        class="toast fade"
        id="error-toast-cash"
        style="background-color: rgb(252, 235, 231)"
        role="alert"
        aria-live="polite"
        aria-atomic="true"
      >
        <div class="toast-body d-flex justify-content-between">
          <strong class="me-auto text-danger">{{ errorMessage }}</strong>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="toast"
            aria-label="Close"
          ></button>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modal-checkout-cash"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">ชำระเงิน</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body" id="process-cart">
            <div
              class="tab-pane fade fade-left active show"
              id="btabswo-cash"
              role="tabpanel"
              aria-labelledby="btabswo-cash-tab"
            >
              <div class="container">
                <div class="row">
                  <div class="col-12 mx-auto">
                    <div class="container">
                      <div class="row">
                        <div class="col-md-12 mx-auto py-2">
                          <div class="d-flex flex-row justify-content-between">
                            <div>
                              <p>ราคารวม</p>
                            </div>
                            <div>
                              <h3 class="text-black">{{ total_text }}</h3>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <div class="group" style="position: relative">
                                <span
                                  class="bg-white p-2 fs-5"
                                  style="
                                    position: absolute;
                                    right: 6%;
                                    top: -20px;
                                    z-index: 99;
                                  "
                                  >จำนวนเงินที่รับมา</span
                                >
                                <div class="input-group mb-3">
                                  <span
                                    class="input-group-text bg-white fs-2 text-black-60"
                                    id="basic-addon1"
                                    >฿</span
                                  >
                                  <input
                                    id="c-pay-input"
                                    type="text"
                                    class="form-control bg-white form-control-lg fs-2 fw-bold text-black text-end"
                                    style="border-left: 0px"
                                    placeholder=""
                                    v-model="pay"
                                    v-on:keyup.enter="checkout()"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row gx-2">
                            <div class="col-4">
                              <button
                                class="btn btn-light w-100"
                                @click="addQty(100)"
                              >
                                100
                              </button>
                            </div>
                            <div class="col-4">
                              <button
                                class="btn btn-light w-100"
                                @click="addQty(500)"
                              >
                                500
                              </button>
                            </div>
                            <div class="col-4">
                              <button
                                class="btn btn-light w-100"
                                @click="addQty(1000)"
                              >
                                1000
                              </button>
                            </div>
                          </div>
                          <div class="row my-3 gx-2">
                            <div class="col-8">
                              <div class="row gx-2 gy-2">
                                <div class="col-4">
                                  <button
                                    class="btn btn-light w-100 btn-numpad-normal"
                                    @click="numpad(7)"
                                  >
                                    7
                                  </button>
                                </div>
                                <div class="col-4">
                                  <button
                                    class="btn btn-light w-100 btn-numpad-normal"
                                    @click="numpad(8)"
                                  >
                                    8
                                  </button>
                                </div>
                                <div class="col-4">
                                  <button
                                    class="btn btn-light w-100 btn-numpad-normal"
                                    @click="numpad(9)"
                                  >
                                    9
                                  </button>
                                </div>
                                <div class="col-4">
                                  <button
                                    class="btn btn-light w-100 btn-numpad-normal"
                                    @click="numpad(4)"
                                  >
                                    4
                                  </button>
                                </div>
                                <div class="col-4">
                                  <button
                                    class="btn btn-light w-100 btn-numpad-normal"
                                    @click="numpad(5)"
                                  >
                                    5
                                  </button>
                                </div>
                                <div class="col-4">
                                  <button
                                    class="btn btn-light w-100 btn-numpad-normal"
                                    @click="numpad(6)"
                                  >
                                    6
                                  </button>
                                </div>
                                <div class="col-4">
                                  <button
                                    class="btn btn-light w-100 btn-numpad-normal"
                                    @click="numpad(1)"
                                  >
                                    1
                                  </button>
                                </div>
                                <div class="col-4">
                                  <button
                                    class="btn btn-light w-100 btn-numpad-normal"
                                    @click="numpad(2)"
                                  >
                                    2
                                  </button>
                                </div>
                                <div class="col-4">
                                  <button
                                    class="btn btn-light w-100 btn-numpad-normal"
                                    @click="numpad(3)"
                                  >
                                    3
                                  </button>
                                </div>
                                <div class="col-4">
                                  <button
                                    class="btn btn-light w-100 btn-numpad-normal"
                                    @click="numpad('00')"
                                  >
                                    00
                                  </button>
                                </div>
                                <div class="col-4">
                                  <button
                                    class="btn btn-light w-100 btn-numpad-normal"
                                    @click="numpad(0)"
                                  >
                                    0
                                  </button>
                                </div>
                                <div class="col-4">
                                  <button
                                    class="btn btn-light w-100 btn-numpad-normal"
                                    @click="numpad('.')"
                                  >
                                    .
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="col-4">
                              <div class="d-flex flex-column h-100 gap-2">
                                <button
                                  class="btn btn-light w-100 h-100 btn-numpad-height"
                                  @click="numpad('bsp')"
                                >
                                  <i class="fa fa-backspace"></i>
                                </button>
                                <button
                                  class="btn btn-light w-100 h-100 btn-numpad-height fs-3"
                                  @click="numpad('clear')"
                                >
                                  C
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="row mb-4">
                            <div class="col-12">
                              <label for="patient_symptoms">อาการผู้ป่วย</label>
                              <textarea
                                class="form-control"
                                name=""
                                id="patient_symptoms"
                                v-model="patientInfo"
                                cols="30"
                                rows="2"
                              ></textarea>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="row">
                              <div class="col-12">
                                <button
                                  class="btn btn-lg btn-primary w-100"
                                  id="checkout-cash-btn"
                                  @click="checkout()"
                                >
                                  ชำระเงิน
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "bootstrap";
export default {
  props: ["cartDetails", "patientInfo"],
  data() {
    return {
      pay: "",
      errorMessage: "",
      toast: null,
    };
  },
  mounted() {
    let toastElList = document.querySelector("#error-toast-cash");
    this.toast = new Toast(toastElList, {
      animation: true,
      delay: 3000,
    });
  },
  computed: {
    total_text() {
      return this.cartDetails.total_text;
    },
  },
  watch: {
    pay(newValue, oldValue) {
      if (String(newValue).length > 12 && newValue > 999999999.99) {
        this.pay = String(this.pay).substring(
          0,
          [String(this.pay).length - 1],
          1
        );
        this.errorMessage = "ยอดเงินเกิน 100 ล้าน";
        this.toast.show();
      } else {
        if (parseInt(newValue) != 0 && parseInt(oldValue) != 0) {
          if (String(newValue).slice(-1) == ".") {
            let checkDot = newValue.split(".");
            if (checkDot.length > 2) {
              this.pay = oldValue;
            }
          } else {
            if (window.isDecimal(newValue) && newValue != "") {
              let checkDecimalLenght = String(newValue).split(".");
              if (
                checkDecimalLenght.length >= 2 &&
                checkDecimalLenght.slice(-1)[0].length > 2
              ) {
                this.pay = parseFloat(
                  String(this.pay).substring(
                    0,
                    [String(this.pay).length - 1],
                    1
                  )
                );
              }
            } else {
              this.pay = oldValue;
              if (newValue == "") {
                this.pay = 0;
              }
            }
          }
        } else {
          this.pay = parseInt(newValue);
        }
      }
    },
  },
  methods: {
    async checkout() {
      if (parseFloat(this.pay) < parseFloat(this.cartDetails.total)) {
        this.errorMessage = "ยอดเงินไม่เพียงพอ";
        this.toast.show();
      } else {
        this.$emit("confirm", {
          pay: this.pay,
          patient_info: this.patientInfo,
        });
        document.querySelector("#checkout-cash-btn").disabled = true;
      }
    },
    numpad(number) {
      if (number == "bsp") {
        this.pay = String(this.pay).substring(
          0,
          [String(this.pay).length - 1],
          1
        );
        if (this.pay.length <= 0) {
          this.pay = "0";
        }
      } else if (number == "clear") {
        this.pay = "0";
      } else {
        if (number == ".") {
          this.pay += "" + number;
        } else {
          this.pay += "" + number;
          let checkDecimalLenght = String(this.pay).split(".");
          if (
            checkDecimalLenght.length >= 2 &&
            checkDecimalLenght[checkDecimalLenght.length - 1].length > 2
          ) {
            this.pay = String(this.pay).substring(
              0,
              [String(this.pay).length - 1],
              1
            );
          }
          // console.log(this.pay);
          if (number != "0" && number != "00") {
            this.pay = this.pay.replaceAll(" ", "");
            this.pay = parseFloat(this.pay);
          }
        }
      }
    },
    addQty(qty) {
      this.pay = parseFloat(this.pay);
      this.pay += parseFloat(qty);
    },
  },
};
</script>
